import React, { useEffect, useState, useRef } from "react";
import Pagination from "../../components/Pagination";
import { GET_NEWS_BULLETIN_LIST, GET_NEWS_BULLETIN } from "../../utils/constants";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import useWindowWidth from "../../utils/windowWidth";
import Timeline from "../../components/NewsPage/Timeline";
import axios from "axios";
import { Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';


export const Card = (props: any) => {
  const { job, isPlaying, onPlayPauseClick, language, isExpanded } = props;
  const [audioBlobUrl, setAudioBlobUrl] = useState<string | null>(null);
  const [isLoadingAudio, setIsLoadingAudio] = useState<boolean>(false);

  const formattedDate = new Date(
    job.split("-").reverse().join("-")
  ).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  const togglePlayPause = () => {
    onPlayPauseClick();
  };
  
  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    togglePlayPause();
  };

  useEffect(() => {
    if (isPlaying && !audioBlobUrl && !isLoadingAudio) {
      setIsLoadingAudio(true);
      const [day, month, year] = job.split('-');
      const dateParam = `${day}-${month}-${year}`; // Format to DD-MM-YYYY
      const langParam = language;
      console.log('lang', language)

      const fetchAudio = async () => {
        try {
          const response = await axios.get(
            `${GET_NEWS_BULLETIN}/${langParam}/${dateParam}`,
            {
              responseType: 'arraybuffer',
            }
          );
          const blob = new Blob([response.data], { type: 'audio/mpeg' });
          const url = URL.createObjectURL(blob);
          setAudioBlobUrl(url);
        } catch (error) {
          console.error("Error fetching audio:", error);
          setAudioBlobUrl(null); // Reset on error
        } finally {
          setIsLoadingAudio(false);
        }
      };
      fetchAudio();
    }
  }, [isPlaying, audioBlobUrl, isLoadingAudio, job, language]);

  // Effect to revoke old audioBlobUrl when it changes or component unmounts
  useEffect(() => {
    const currentAudioBlobUrl = audioBlobUrl;
    return () => {
      if (currentAudioBlobUrl) {
        URL.revokeObjectURL(currentAudioBlobUrl);
      }
    };
  }, [audioBlobUrl]);

  useEffect(() => {
    setAudioBlobUrl(null);
    setIsLoadingAudio(false);
  }, [job, language]);

  return (
    <article style={{ width: "100%" }}
      aria-labelledby={`news-title-${job.id}`}
      tabIndex={0}
    >
      <div
        className="opportunity-card news-article"
        style={{
          transition: "max-height 0.3s ease, padding 0.3s ease",
          maxHeight: isExpanded ? "240px" : "120px", // Use isExpanded here
          paddingBottom: isExpanded ? "12px" : "0px",
          paddingTop: isExpanded ? "12px" : "0px",
          overflow: "hidden",
        }}
      >
        <div
          className="d-flex flex-column"
          style={{ width: '100%' }}
        >
          <div
            className="d-flex align-items-center"
            style={{ width: "100%" }}
          >
            <Button 
              className="play-pause-btn" 
              onClick={handleButtonClick} 
              disabled={isLoadingAudio} 
              variant="primary" 
              aria-label={isPlaying ? "Pause news bulletin" : "Play news bulletin"}
            >
              {isLoadingAudio ? (
                <Spinner animation="border" size="sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} size="lg" />
              )}
            </Button>
            <div style={{ paddingLeft: "10px" }}>
              <h3 className="card-title news-title m-0">{formattedDate}</h3>
            </div>
          </div>

          {audioBlobUrl && isExpanded && ( 
            <div style={{ marginTop: "10px", width: "100%", padding:"6px" }}>
              <Timeline
                audioUrl={audioBlobUrl}
                isPlaying={isPlaying}
                onPlayPause={togglePlayPause}
              />
            </div>
          )}
          {isLoadingAudio && isExpanded && ( // Show loading only if expanded
            <div style={{ marginTop: "10px", width: "100%", textAlign: "center" }}>
              Loading audio...
            </div>
          )}
        </div>
       
      </div>
    </article>
  );
};

const NewsList = (props: any) => {
  const { language } = props;
  const [playingIndex, setPlayingIndex] = useState<number | null>(null);
  const [lastPlayedIndex, setLastPlayedIndex] = useState<number | null>(null);

  const handlePlayPause = (index: number) => {
    setPlayingIndex(prevIndex => {
      if (prevIndex === index) {
        // Pausing the current item
        setLastPlayedIndex(index); // Remember this as the last played
        return null;
      } else {
        // Playing a new item
        setLastPlayedIndex(index); // Remember this as the last played
        return index;
      }
    });
  };


  return (
    <>
      <div
        className="card-container mt-[2rem]"
        style={{ gap: "1rem", padding: "2rem 0", paddingLeft: '2rem' }}
      >
        {props.jobs &&
          props.jobs.map((job: any, index: any) => {
            return (
              <Card
                job={job}
                key={index}
                isPlaying={playingIndex === index}
                onPlayPauseClick={() => handlePlayPause(index)}
                language={language}
                isExpanded={playingIndex === index || lastPlayedIndex === index}
              />
            );
          })}
      </div>
      <nav className="pagination-container" aria-label="Pagination navigation">
        <Pagination
          pageNumber={props.page}
          totalPages={props.totalPages}
          onPageChange={props.onPageChange}
        />
      </nav>
    </>
  );
};

export default NewsList;